import { Application } from '@hotwired/stimulus'

const application = Application.start()

const CONTROLLER_FILENAME_REGEX =
  /^(?:.*?(?:controllers|components)\/|\.?\.\/)?(.+?)(?:(?:[_-]component)?[_-]controller\..+?)$/

function identifierForGlobKey(key) {
  const logicalName = (key.match(CONTROLLER_FILENAME_REGEX) || [])[1]
  if (logicalName) return logicalName.replace(/_/g, '-').replace(/\//g, '--')
}

function registerControllers(application, controllerModules) {
  const definitions = Object.entries(controllerModules)
    .map(([name, mod]) => {
      const identifier = identifierForGlobKey(name)
      const controllerConstructor = mod.default
      if (identifier && typeof controllerConstructor === 'function')
        return { identifier, controllerConstructor }
    })
    .filter(Boolean)

  application.load(definitions)
}

const controllers = import.meta.globEager(
  ['./**/*_controller.js', '../../components/**/*_controller.js']
)
registerControllers(application, controllers)
